import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_8afee67c from 'nuxt_plugin_plugin_8afee67c' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_workbox_54118ae8 from 'nuxt_plugin_workbox_54118ae8' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_46e3359f from 'nuxt_plugin_metaplugin_46e3359f' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_4b8adb13 from 'nuxt_plugin_iconplugin_4b8adb13' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_distplugin346deb3c_76a38746 from 'nuxt_plugin_distplugin346deb3c_76a38746' // Source: ./dist.plugin.346deb3c.mjs (mode: 'all')
import nuxt_plugin_launchdarkly_40cb685e from 'nuxt_plugin_launchdarkly_40cb685e' // Source: ../../../src/plugins/launch-darkly.js (mode: 'all')
import nuxt_plugin_lodash_73e54c4b from 'nuxt_plugin_lodash_73e54c4b' // Source: ../../../src/plugins/lodash.js (mode: 'all')
import nuxt_plugin_buefy_d1269c2e from 'nuxt_plugin_buefy_d1269c2e' // Source: ../../../src/plugins/buefy.js (mode: 'all')
import nuxt_plugin_commons_e4f777b4 from 'nuxt_plugin_commons_e4f777b4' // Source: ../../../src/plugins/commons.js (mode: 'all')
import nuxt_plugin_mixins_6f76c2a4 from 'nuxt_plugin_mixins_6f76c2a4' // Source: ../../../src/plugins/mixins.js (mode: 'all')
import nuxt_plugin_fullstory_5581ffe9 from 'nuxt_plugin_fullstory_5581ffe9' // Source: ../../../src/plugins/full-story.js (mode: 'all')
import nuxt_plugin_directives_5f2656fc from 'nuxt_plugin_directives_5f2656fc' // Source: ../../../src/plugins/directives.js (mode: 'all')
import nuxt_plugin_filters_2b4f519a from 'nuxt_plugin_filters_2b4f519a' // Source: ../../../src/plugins/filters.js (mode: 'all')
import nuxt_plugin_vuenotifications_d1eda866 from 'nuxt_plugin_vuenotifications_d1eda866' // Source: ../../../src/plugins/vue-notifications.js (mode: 'all')
import nuxt_plugin_axios_5659cf26 from 'nuxt_plugin_axios_5659cf26' // Source: ../../../src/plugins/axios.ts (mode: 'all')
import nuxt_plugin_lottieplayer_aefa6384 from 'nuxt_plugin_lottieplayer_aefa6384' // Source: ../../../src/plugins/lottie-player.js (mode: 'client')
import nuxt_plugin_pwarefresh_29329bdb from 'nuxt_plugin_pwarefresh_29329bdb' // Source: ../../../src/plugins/pwa-refresh.ts (mode: 'client')
import nuxt_plugin_apolloClient_55a45844 from 'nuxt_plugin_apolloClient_55a45844' // Source: ../../../src/gql/apolloClient.ts (mode: 'client')
import nuxt_plugin_cleavecomponent_2f17a79c from 'nuxt_plugin_cleavecomponent_2f17a79c' // Source: ../../../src/plugins/cleave-component.js (mode: 'all')
import nuxt_plugin_setToken_6ce9e8ae from 'nuxt_plugin_setToken_6ce9e8ae' // Source: ../../../src/plugins/setToken.js (mode: 'client')
import nuxt_plugin_segment_f1d01e0a from 'nuxt_plugin_segment_f1d01e0a' // Source: ../../../src/plugins/segment.js (mode: 'client')
import nuxt_plugin_intercom_06bd687b from 'nuxt_plugin_intercom_06bd687b' // Source: ../../../src/plugins/intercom.js (mode: 'client')
import nuxt_plugin_filestack_01ece142 from 'nuxt_plugin_filestack_01ece142' // Source: ../../../src/plugins/filestack.js (mode: 'client')
import nuxt_plugin_velocity_5d794fc3 from 'nuxt_plugin_velocity_5d794fc3' // Source: ../../../src/plugins/velocity.js (mode: 'client')
import nuxt_plugin_portal_6e02f7d8 from 'nuxt_plugin_portal_6e02f7d8' // Source: ../../../src/plugins/portal.js (mode: 'all')
import nuxt_plugin_vtooltip_431cebbc from 'nuxt_plugin_vtooltip_431cebbc' // Source: ../../../src/plugins/v-tooltip.js (mode: 'all')
import nuxt_plugin_clientInit_00696225 from 'nuxt_plugin_clientInit_00696225' // Source: ../../../src/plugins/clientInit.js (mode: 'client')
import nuxt_plugin_vuescrollmonitor_6e993eb0 from 'nuxt_plugin_vuescrollmonitor_6e993eb0' // Source: ../../../src/plugins/vue-scrollmonitor.js (mode: 'client')
import nuxt_plugin_vuelineclamp_06565bd2 from 'nuxt_plugin_vuelineclamp_06565bd2' // Source: ../../../src/plugins/vue-line-clamp.js (mode: 'client')
import nuxt_plugin_vuecalendly_72de5ec2 from 'nuxt_plugin_vuecalendly_72de5ec2' // Source: ../../../src/plugins/vue-calendly.js (mode: 'all')
import nuxt_plugin_vuescreen_c32dc7e6 from 'nuxt_plugin_vuescreen_c32dc7e6' // Source: ../../../src/plugins/vue-screen.js (mode: 'all')
import nuxt_plugin_vueapollo_34aa2c00 from 'nuxt_plugin_vueapollo_34aa2c00' // Source: ../../../src/plugins/vue-apollo.ts (mode: 'all')
import nuxt_plugin_maska_043c64ef from 'nuxt_plugin_maska_043c64ef' // Source: ../../../src/plugins/maska.ts (mode: 'all')
import nuxt_plugin_pinia_4b254b7e from 'nuxt_plugin_pinia_4b254b7e' // Source: ../../../src/plugins/pinia.js (mode: 'all')
import nuxt_plugin_meta_156e9f58 from 'nuxt_plugin_meta_156e9f58' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Bambee","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, minimal-ui"},{"hid":"description","content":"Bambee: On Demand HR for Small Business."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fsweetalert\u002F1.1.3\u002Fsweetalert.min.css"},{"rel":"stylesheet","href":"\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fdriver.js@1.0.1\u002Fdist\u002Fdriver.css"},{"rel":"stylesheet","href":"\u002F\u002Fmaxcdn.bootstrapcdn.com\u002Ffont-awesome\u002F4.7.0\u002Fcss\u002Ffont-awesome.min.css"},{"rel":"stylesheet","href":"\u002F\u002Fcdn.materialdesignicons.com\u002F2.0.46\u002Fcss\u002Fmaterialdesignicons.min.css"},{"rel":"stylesheet","href":"\u002F\u002Fs3.amazonaws.com\u002Fpd-js-sdk\u002F0.2.16\u002Fpandadoc-js-sdk.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.typekit.net\u002Flnf2zzq.css"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fstatic.asknice.ly\u002Fdist\u002Fstandalone\u002Fasknicely-in-app-conversation.css"}],"script":[{"hid":"datadog","src":"https:\u002F\u002Fwww.datadoghq-browser-agent.com\u002Fdatadog-rum-v4.js","type":"text\u002Fjavascript"},{"hid":"datadog-init","innerHTML":"\n                if(window.DD_RUM){\n                  \u002F**\n * This file serves as a way to handle Datadog RUM events before they are sent as errors. Passing the function in nuxt.config.js scripts block\n *  https:\u002F\u002Fdocs.datadoghq.com\u002Freal_user_monitoring\u002Fguide\u002Fenrich-and-control-rum-data\u002F?tab=event#event-and-context-structure\n * @typedef {import('@datadog\u002Fbrowser-rum').RumInitConfiguration['beforeSend']} BeforeSend\n * @type {BeforeSend} *\u002F\nconst beforeSend = (event, context) =\u003E {\n  const excludeList = [\n    'newestWorker is null',\n    'LD: [error] network error (Error)',\n    'Failed to update a ServiceWorker',\n    'sw.js load failed',\n    'Error sending segment performance metrics',\n    'Function statements must have a name',\n    'Function statements require a function name',\n  ];\n\n  \u002F\u002F Add Errors to be excluded below\n  const matchError = (errorMessageToExclude) =\u003E {\n    \u002F\u002F simple string matches\n    const isErrorMessageIncluded = !!event.error?.message.includes(\n      errorMessageToExclude\n    );\n\n    \u002F\u002F compute regex patterns\n\n    \u002F\u002F harmless error thrown by iframe https:\u002F\u002Fapp.datadoghq.com\u002Frum\u002Fsessions?query=%40view.name%3A%22%2Fpayroll%2F%3F%2Fedit%22%20env%3Aproduction%20%40type%3Aerror&cols=&event=AgAAAYjfaorTMLS60wAAAAAAAAAYAAAAAEFZamZhb3lXQUFEU0J3Ql9qVVNlWWdBQQAAACQAAAAAMDE4OGRmOGEtNTdmOS00NTI3LWE1YTktYzZmOWM1MmE3ZjUz&viz=stream&from_ts=1686328171140&to_ts=1687537771140&live=true\n    const isErrorMatchingPattern = !!event.error?.message.match(\n      \u002FFailed to execute 'querySelectorAll' on 'Document': 'div:has\\(\u003E iframe\\[id='.*'\\]\\)' is not a valid selector\u002F\n    );\n\n    return isErrorMessageIncluded || isErrorMatchingPattern;\n  };\n\n  if (event.error && excludeList.some(matchError)) {\n    console.warn('Datadog Event Ignored:', event.error);\n\n    return false;\n  }\n\n  return true;\n};\n\n                  window.DD_RUM.init({\n                    applicationId: 'ed939270-5bcb-4514-8dea-9d7ec22d9bd7',\n                    clientToken: 'pubf24bf4bc25e23eb586578082b633c1ee',\n                    site: 'datadoghq.com',\n                    service: 'app',\n                    env: 'production',\n                    version: '9cef676425a2fee7c2c843ec14ea5464514e161c',\n                    sampleRate: 100,\n                    sessionReplaySampleRate: 100,\n                    tracingSampleRate: 100,\n                    trackResources: true,\n                    trackLongTasks: true,\n                    trackInteractions: true,\n                    trackFrustrations: true,\n                    trackSessionAcrossSubdomains: true,\n                    allowedTracingOrigins: [\u002Fhttps:\\\u002F\\\u002F.*\\.bambee\\.com\u002F],\n                    enableExperimentalFeatures: ['clickmap'],\n                    silentMultipleInit: true,\n                    useCrossSiteSessionCookie: true,\n                    beforeSend,\n                    defaultPrivacyLevel: 'allow'\n                  })\n\n                  window.DD_RUM.startSessionReplayRecording();\n                }"},{"src":"\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fsweetalert\u002F1.1.3\u002Fsweetalert.min.js"},{"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3\u002F"},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Ftween.js\u002F16.3.5\u002FTween.min.js"},{"src":"\u002F\u002Fs3.amazonaws.com\u002Fpd-js-sdk\u002F0.2.16\u002Fpandadoc-js-sdk.min.js"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-Q9ZP364ZFM","async":true},{"src":"https:\u002F\u002Fstatic.asknice.ly\u002Fdist\u002Fstandalone\u002Fasknicely-in-app-conversation.js","body":true},{"hid":"google-analytics","innerHTML":"window.dataLayer = window.dataLayer || [];\n                        function gtag() {\n                          dataLayer.push(arguments);\n                        }\n                        gtag('js', new Date());\n\n                        gtag('config', 'G-Q9ZP364ZFM');\n\n                        "}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_8afee67c === 'function') {
    await nuxt_plugin_plugin_8afee67c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_54118ae8 === 'function') {
    await nuxt_plugin_workbox_54118ae8(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_46e3359f === 'function') {
    await nuxt_plugin_metaplugin_46e3359f(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_4b8adb13 === 'function') {
    await nuxt_plugin_iconplugin_4b8adb13(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin346deb3c_76a38746 === 'function') {
    await nuxt_plugin_distplugin346deb3c_76a38746(app.context, inject)
  }

  if (typeof nuxt_plugin_launchdarkly_40cb685e === 'function') {
    await nuxt_plugin_launchdarkly_40cb685e(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_73e54c4b === 'function') {
    await nuxt_plugin_lodash_73e54c4b(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_d1269c2e === 'function') {
    await nuxt_plugin_buefy_d1269c2e(app.context, inject)
  }

  if (typeof nuxt_plugin_commons_e4f777b4 === 'function') {
    await nuxt_plugin_commons_e4f777b4(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_6f76c2a4 === 'function') {
    await nuxt_plugin_mixins_6f76c2a4(app.context, inject)
  }

  if (typeof nuxt_plugin_fullstory_5581ffe9 === 'function') {
    await nuxt_plugin_fullstory_5581ffe9(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_5f2656fc === 'function') {
    await nuxt_plugin_directives_5f2656fc(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2b4f519a === 'function') {
    await nuxt_plugin_filters_2b4f519a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuenotifications_d1eda866 === 'function') {
    await nuxt_plugin_vuenotifications_d1eda866(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659cf26 === 'function') {
    await nuxt_plugin_axios_5659cf26(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lottieplayer_aefa6384 === 'function') {
    await nuxt_plugin_lottieplayer_aefa6384(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pwarefresh_29329bdb === 'function') {
    await nuxt_plugin_pwarefresh_29329bdb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_apolloClient_55a45844 === 'function') {
    await nuxt_plugin_apolloClient_55a45844(app.context, inject)
  }

  if (typeof nuxt_plugin_cleavecomponent_2f17a79c === 'function') {
    await nuxt_plugin_cleavecomponent_2f17a79c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_setToken_6ce9e8ae === 'function') {
    await nuxt_plugin_setToken_6ce9e8ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_segment_f1d01e0a === 'function') {
    await nuxt_plugin_segment_f1d01e0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intercom_06bd687b === 'function') {
    await nuxt_plugin_intercom_06bd687b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_filestack_01ece142 === 'function') {
    await nuxt_plugin_filestack_01ece142(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_velocity_5d794fc3 === 'function') {
    await nuxt_plugin_velocity_5d794fc3(app.context, inject)
  }

  if (typeof nuxt_plugin_portal_6e02f7d8 === 'function') {
    await nuxt_plugin_portal_6e02f7d8(app.context, inject)
  }

  if (typeof nuxt_plugin_vtooltip_431cebbc === 'function') {
    await nuxt_plugin_vtooltip_431cebbc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientInit_00696225 === 'function') {
    await nuxt_plugin_clientInit_00696225(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollmonitor_6e993eb0 === 'function') {
    await nuxt_plugin_vuescrollmonitor_6e993eb0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelineclamp_06565bd2 === 'function') {
    await nuxt_plugin_vuelineclamp_06565bd2(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecalendly_72de5ec2 === 'function') {
    await nuxt_plugin_vuecalendly_72de5ec2(app.context, inject)
  }

  if (typeof nuxt_plugin_vuescreen_c32dc7e6 === 'function') {
    await nuxt_plugin_vuescreen_c32dc7e6(app.context, inject)
  }

  if (typeof nuxt_plugin_vueapollo_34aa2c00 === 'function') {
    await nuxt_plugin_vueapollo_34aa2c00(app.context, inject)
  }

  if (typeof nuxt_plugin_maska_043c64ef === 'function') {
    await nuxt_plugin_maska_043c64ef(app.context, inject)
  }

  if (typeof nuxt_plugin_pinia_4b254b7e === 'function') {
    await nuxt_plugin_pinia_4b254b7e(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_156e9f58 === 'function') {
    await nuxt_plugin_meta_156e9f58(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
